import {Component} from '@angular/core';
import { BreadCrumbElement } from '../../../shared/entities/breadcrumb.element.entity';
import { ActivatedRoute } from '@angular/router';
import { EventsService } from '../../../services/events/events.service';
import { LoadingIndicatorService } from '../../../services/loading-indicator/loading-indicator.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-user-user-info',
  templateUrl: './user-info.component.html'
})
export class UserInfoComponent {
  /* */
  public breadCrumbElements: Array<BreadCrumbElement> = [];

  /* */
  public backgroundImage = '/assets/media/photos/photo21@2x.jpg';
  public containerBackgroundImage = {'background-image': 'url(' + this.backgroundImage + ')'};
  public subContainerBackgroundImage = {};
  public containerClass = {'bg-image': true};
  public subContainerClass = {'bg-white-op-90': true};
  public contentClass: any = {'content': true, 'text-center': true, 'content-top': true};
  public pyClass = {'py-50': true};
  public h1class: any = {'h1': true};
  public h2class: any = {'h4': true};

  /* */
  public userId: string;
  public user: any;

  /* */
  public housing;

  /* */
  constructor(private activatedRoute: ActivatedRoute,
              private eventsService: EventsService,
              private loadingIndicatorService: LoadingIndicatorService,
              private http: HttpClient) {
    this.userId = this.activatedRoute.snapshot.params['userId'];
    this.requestData();

    this.eventsService.on("userInfoReloadUserData", () => {
      this.requestData();
    });
  }

  public requestData() {
    this.loadingIndicatorService.showLoadingBar();

    this.http.get(environment.urls.service + '/api/v1/authenticated/admin/user/' + this.userId)
      .subscribe((response: any) => {
          this.loadingIndicatorService.hideLoadingBar();
          console.log(response);
          this.user = response.user;
          this.updateBreadcrumb();
        },
        err => {
          this.loadingIndicatorService.hideLoadingBar();
        });
  }

  updateBreadcrumb() {
    this.breadCrumbElements = [
      new BreadCrumbElement('tripmakery', 'javascript:void(0)'),
      new BreadCrumbElement('Users', 'javascript:void(0)'),
      new BreadCrumbElement(this.userId, 'javascript:void(0)')
    ];
  }

}
